import { render, staticRenderFns } from "./ReadyCaseStudy.vue?vue&type=template&id=147eb4c0&scoped=true"
import script from "./ReadyCaseStudy.vue?vue&type=script&lang=js"
export * from "./ReadyCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./ReadyCaseStudy.vue?vue&type=style&index=0&id=147eb4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147eb4c0",
  null
  
)

export default component.exports